import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { getDateWisePayments } from '../../actions';

const fmt = (d) => (d ? moment(d).format('DD/MM/YYYY , hh:mm A') : '—');
const fmtDate = (d) => (d ? moment(d).format('DD MMM YYYY') : '—');

const PaymentDetail = () => {
  const dispatch = useDispatch();
  const { subscriptionId } = useParams();

  const list = useSelector((state) => state.home.paymentList);

  useEffect(() => {
    if (!list || !list.length) dispatch(getDateWisePayments());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const p = (list || []).find((r) => r.subscriptionId === subscriptionId) || {};

  const label = { color: '#7b8aa5', fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '0.03em' };
  const value = { fontWeight: 600, color: '#1b2a4e' };

  return (
    <div className="pcoded-inner-content">
      <div className="main-body">
        <div className="page-wrapper">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <h4 style={{ fontWeight: 600 }}>Payment Receipt</h4>
            <div>
              <button className="btn btn-sm btn-outline-dark mr-2" onClick={() => window.print()}>Print</button>
              <Link to="/payment" className="btn btn-sm btn-outline-dark">Back</Link>
            </div>
          </div>

          <div
            style={{
              maxWidth: 820,
              margin: '0 auto',
              background: '#fff',
              borderRadius: 10,
              boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
              overflow: 'hidden',
            }}
          >
            {/* Header band */}
            <div style={{ background: '#1b2a4e', color: '#fff', padding: '1.5rem 2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <div style={{ fontSize: '1.5rem', fontWeight: 700, letterSpacing: '0.04em' }}>CARS AVENUE</div>
                <div style={{ opacity: 0.7, fontSize: '0.85rem', marginTop: 4 }}>Subscription Receipt</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ opacity: 0.7, fontSize: '0.75rem' }}>RECEIPT NO.</div>
                <div style={{ fontWeight: 600, fontSize: '0.9rem', wordBreak: 'break-all', maxWidth: 260 }}>
                  {p.transactionId || p.subscriptionId || '—'}
                </div>
                <div style={{ marginTop: 8 }}>
                  <span
                    style={{
                      background: p.active ? '#28a745' : '#dc3545',
                      borderRadius: 12,
                      padding: '2px 12px',
                      fontSize: '0.75rem',
                      fontWeight: 600,
                    }}
                  >
                    {p.active ? 'ACTIVE' : 'EXPIRED'}
                  </span>
                </div>
              </div>
            </div>

            {/* Billed to + payment */}
            <div style={{ display: 'flex', flexWrap: 'wrap', padding: '1.5rem 2rem', gap: '2rem', borderBottom: '1px solid #eef1f6' }}>
              <div style={{ flex: '1 1 240px' }}>
                <div style={label}>Billed To</div>
                <div style={{ ...value, fontSize: '1.05rem', marginTop: 4 }}>{p.username || '—'}</div>
                <div style={{ color: '#7b8aa5', fontSize: '0.85rem' }}>Account status: {p.userStatus || '—'}</div>
              </div>
              <div style={{ flex: '1 1 200px' }}>
                <div style={label}>Payment Date</div>
                <div style={{ ...value, marginTop: 4 }}>{fmt(p.createdAt)}</div>
              </div>
              <div style={{ flex: '1 1 160px' }}>
                <div style={label}>Payment Method</div>
                <div style={{ ...value, marginTop: 4 }}>{p.paymentType || '—'}</div>
              </div>
            </div>

            {/* Line item table */}
            <div style={{ padding: '1.5rem 2rem' }}>
              <table className="table" style={{ marginBottom: 0 }}>
                <thead>
                  <tr style={{ color: '#7b8aa5', fontSize: '0.8rem' }}>
                    <th style={{ border: 'none' }}>Description</th>
                    <th style={{ border: 'none' }}>Plan</th>
                    <th style={{ border: 'none' }}>Valid From</th>
                    <th style={{ border: 'none' }}>Valid Until</th>
                    <th style={{ border: 'none', textAlign: 'right' }}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ ...value }}>
                      Membership Subscription
                      <div style={{ color: '#7b8aa5', fontWeight: 400, fontSize: '0.8rem' }}>{p.packageId || ''}</div>
                    </td>
                    <td>{p.subscriptionPlan || p.packageName || '—'}</td>
                    <td>{fmtDate(p.startDate || p.createdAt)}</td>
                    <td>{fmtDate(p.expiry)}</td>
                    <td style={{ textAlign: 'right', ...value }}>{p.amount != null ? `${p.amount} KWD` : '—'}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Totals */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '0 2rem 1.5rem' }}>
              <div style={{ width: 280 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0.35rem 0', color: '#7b8aa5' }}>
                  <span>Package Amount</span>
                  <span>{p.packageAmount != null ? `${p.packageAmount} KWD` : '—'}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0.6rem 0', borderTop: '2px solid #1b2a4e', marginTop: 6 }}>
                  <span style={{ fontWeight: 700, color: '#1b2a4e' }}>Total Paid</span>
                  <span style={{ fontWeight: 700, color: '#1b2a4e', fontSize: '1.1rem' }}>
                    {p.amount != null ? `${p.amount} KWD` : '—'}
                  </span>
                </div>
              </div>
            </div>

            <div style={{ background: '#f6f8fc', padding: '1rem 2rem', color: '#9aa7bd', fontSize: '0.8rem', textAlign: 'center' }}>
              Transaction ID: {p.transactionId || '—'} &nbsp;·&nbsp; Generated by CarsAvenue Admin
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentDetail;
